import { Button } from "@cmp-src/primitives/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@cmp-src/primitives/tooltip";
import { LightningBoltIcon } from "@heroicons/react/outline";
import type { MouseEventHandler } from "react";

export interface QuickReserveButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
  tooltipLabel?: string;
  ariaLabel?: string;
  className?: string;
}

export const QuickReserveButton = ({
  onClick,
  isLoading,
  disabled,
  tooltipLabel = "Quick reserve at 8am - 5PM",
  ariaLabel = "Quick reserve",
  className
}: QuickReserveButtonProps) => {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          aria-label={ariaLabel}
          isLoading={isLoading}
          disabled={disabled}
          onClick={onClick}
          className={className}
        >
          <LightningBoltIcon className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-xs">{tooltipLabel}</p>
      </TooltipContent>
    </Tooltip>
  );
};
